import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import BannerEnum from '../enumerators/banner.enum'

export default class BannerSliderComponent {
    constructor() {
        BannerSliderComponent.init()
    }

    static async init() {
        const options = {
            slidesPerView: 'auto',
            effect: 'fade',
            speed: 500,
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: 6000,
            },
            mousewheel: {
                forceToAxis: true,
            },
            grabCursor: true,
            loop: true,
            pagination: {
                el: '[data-pagination="header-slider-pagination"]',
                type: 'bullets',
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
        }

        // insert navigation / pagination
        $(`${BannerEnum.SLIDER}> *`)
            .wrapAll('<div class="swiper-wrapper"></div>')
            .addClass('swiper-slide')

        await Swiper.create(BannerEnum.SLIDER, options)
    }
}
